export enum RateGroupSettlementType {
    Automatic = 'Automatic',
    Manual = 'Manual',
}
